module.exports = __webpack_public_path__ + "static/img/strona_057.6876a83d.jpg";